import {
    AccordionSummary,
    Box,
    styled,
    Switch,
    TableContainer,
    TableRow,
} from "@mui/material";

export const S = {
    View: styled(TableContainer)(({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
    })),
    Header: styled(Box)(({ theme }) => ({
        margin: theme.spacing(8, 0, 4),
    })),
    Classifications: styled(Box)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    })),
    HeaderRow: styled(TableRow)(({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
    })),
    Switch: styled(Switch)(({ theme }) => ({
        width: 40,
        height: 24,
        padding: 0,
        marginRight: theme.spacing(2),
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: theme.palette.primary.main,
                    opacity: 1,
                    border: 0,
                },
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 19,
            height: 19,
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: "#E9E9EA",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500,
            }),
        },
    })),
    Summary: styled(AccordionSummary)(({ theme }) => ({
        margin: theme.spacing(0, 2),

        "& .MuiAccordionSummary-content": {
            display: "flex",
            alignItems: "center",
            gap: 12,
        },
    })),
    DisplayMore: styled(Box)(({ theme }) => ({
        gap: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        margin: theme.spacing(2, 2, 0),
    })),
};
